<template>
  <div class="list-group"><slot/></div>
</template>

<script setup>
// Replaces bootstrap-vue's <b-list-group> with the same markup (the app uses no props of it).
defineOptions({
  name: 'BListGroup',
})
</script>
